'use client';

import React, { useState, useEffect } from 'react';
import { ArrowCircleUp } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 rounded-full p-2 shadow-md transition-all duration-300 hover:shadow-lg focus:outline-hidden focus:ring-2 focus:ring-primary focus:ring-offset-2"
      size="icon"
      aria-label="Back to top"
    >
      <ArrowCircleUp className="h-5 w-5" />
      <span className="sr-only">Scroll to top of page</span>
    </Button>
  );
}

export default BackToTopButton;
